const de_translations = {}

export default de_translations
